import ArrowBackIcon from "@mui/icons-material/ArrowBack";
//import { Search, SentimentDissatisfied } from "@mui/icons-material";
import { Avatar, Button, Stack} from "@mui/material"; //TextField, InputAdornment 
import Box from "@mui/material/Box";
import React from "react"; //, { useState } 
import "./Header.css";
import { useHistory } from "react-router-dom"; //Link, 

const Header = ({ children, hasHiddenAuthButtons }) => {

  const history = useHistory();


  const handleLogout=(event=>{
    history.push("/")
    localStorage.clear();
    window.location.reload();
  })
  const handleExplore=(event=>{
    history.push("/");
  })
  const handleLogin=(event=>{
    history.push("/login");
  })
  const handleRegister=(event=>{
    history.push("/register");
  })
    return (
      <Box className="header">
        <Box className="header-title">
            <img src="logo_light.svg" alt="QKart-icon"></img>
        </Box>
        
        {children}
        
        {hasHiddenAuthButtons && <Button
          className="explore-button"
          startIcon={<ArrowBackIcon />}
          variant="text"
          onClick={(event)=>handleExplore(event)}>
          Back to explore
        </Button>}
        {!hasHiddenAuthButtons && localStorage.getItem("username")==null && <Box className="loggedOut">
          <Stack direction={"row"}>
          <Button onClick={(event)=>handleLogin(event)}>LOGIN</Button>
          <Button variant="contained" onClick={(event)=>handleRegister(event)}>REGISTER</Button>
          </Stack>
        </Box>}
        {!hasHiddenAuthButtons && localStorage.getItem("username")!=null && <Box className="loggedIn">
          <Stack spacing={1} direction={"row"}>
          <Avatar src="/public/avatar.png" alt={localStorage.getItem("username")}/>
          <p className="username-text">{localStorage.getItem("username")}</p>
         <Button onClick={(e)=>handleLogout(e)}>LOGOUT</Button>
          </Stack>
        </Box>}
      </Box>
    );
};

export default Header;
